/* AMP Cart Accessibility — Product Links & Price Labels */
(function () {
  const selector = [
    '.amp-cart__upsell-item-title',
    '.amp-cart__cart-line-title'
  ].join(', ');

  // Make cart and upsell product names keyboard accessible.
  function enhanceTitles() {
    document.querySelectorAll(selector).forEach((title) => {
      if (title.getAttribute('role') !== 'link') {
        title.setAttribute('role', 'link');
      }

      if (title.getAttribute('tabindex') !== '0') {
        title.setAttribute('tabindex', '0');
      }
    });
  }

  // Add screen-reader-only labels to regular and discounted prices.
  function enhancePrices() {
    const priceLabels = [
      {
        selector: '.amp-cart__cart-line-price--original',
        label: 'Regular price: '
      },
      {
        selector: '.amp-cart__cart-line-price--discounted',
        label: 'Discounted price: '
      }
    ];

    priceLabels.forEach(({ selector, label }) => {
      document.querySelectorAll(selector).forEach((price) => {
        if (price.querySelector('.amp-a11y-price-label')) return;

        const span = document.createElement('span');
        span.className = 'amp-a11y-price-label';
        span.textContent = label;

        // Visually hide the label while keeping it
        // available to screen readers.
        span.style.position = 'absolute';
        span.style.width = '1px';
        span.style.height = '1px';
        span.style.padding = '0';
        span.style.margin = '-1px';
        span.style.overflow = 'hidden';
        span.style.clip = 'rect(0, 0, 0, 0)';
        span.style.whiteSpace = 'nowrap';
        span.style.border = '0';

        price.prepend(span);
      });
    });
  }

  // Allow Enter to activate AMP's existing product navigation.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;

    const title = event.target.closest(selector);
    if (!title) return;

    event.preventDefault();
    title.click();
  });

  // Apply fixes when the cart loads or AMP updates its contents.
  function init() {
    enhanceTitles();
    enhancePrices();

    const observer = new MutationObserver(() => {
      enhanceTitles();
      enhancePrices();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();